export default __webpack_public_path__ + "static/media/purpleSaas.e9689258.svg";